// extracted by mini-css-extract-plugin
export default {"groupTitle":"SearchResultGroup_groupTitle__5q43K","groupContainer":"SearchResultGroup_groupContainer__+nFWL","groupSeparator":"SearchResultGroup_groupSeparator__5yacy"};